import React, { useEffect } from "react";
import "./Volunteering.css";
import Breadcrumb_Comp from "../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import Common_Title_3 from "../common/common_components/Common_Title_3/Common_Title_3";
import Volunteer_Card from "./volunteer_card/Volunteer_Card";
import { AllVolunteer } from '../../features/admin/common/Slice';
import { useDispatch, useSelector } from 'react-redux';
import { IDS } from "../../utils/IDS";

const Volunteering = () => {



  const dispatch = useDispatch();

  const all_volunteer = useSelector((state) => state.common.all_volunteer);

  useEffect(() => {
    dispatch(AllVolunteer());
  }, [dispatch]);


  const breadcrumbs = [
    { label: "EXPLORE", link: "/explore", active: false },
    {
      label: "VOLUNTEERING",
      link: "",
      active: true,
    },
  ];

  return (
    <section className="Volunteering">
      <div className="container">
        <div className="breadcrump_div">
          <Breadcrumb_Comp data={breadcrumbs} />
        </div>

        <div className="main_content_div">
          <Common_Title_3 titleText="Volunteering" hideSeeAll={true} />


          <div className="row">
            {all_volunteer?.map((item, index) => (
              <div className="col-lg-4 col-sm-6 mb-lg-5 mb-md-3" key={index}>
                <Volunteer_Card item={item} />
              </div>
            ))}
          </div>


        </div>
      </div>
    </section>
  );
};

export default Volunteering;
